
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Product } from "@/lib/types";
import ProductCardHeader from "./ProductCardHeader";
import ProductCardContent from "./ProductCardContent";
import ProductCardFooter from "./ProductCardFooter";
import DeleteProductDialog from "./DeleteProductDialog";
import { Calendar, PlusCircle } from "lucide-react";

interface ProductCardProps {
  product: Product;
  onUpdate: () => void;
  onAddStock: () => void;
  onRecordUsage: () => void;
  onRecordPastUsage: () => void;
  onQuickUsage: () => void;
  onDelete: (productId: string) => void;
}

const ProductCard = ({
  product,
  onUpdate,
  onAddStock,
  onRecordUsage,
  onRecordPastUsage,
  onQuickUsage,
  onDelete,
}: ProductCardProps) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleEditClick = () => {
    console.log(`ProductCard: Edit clicked for product ${product.id}`);
    // Navigation is now handled directly in ProductCardHeader
  };

  const handleDeleteClick = () => {
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    onDelete(product.id);
    setDeleteDialogOpen(false);
  };

  return (
    <>
      <Card className="product-card">
        <ProductCardHeader
          product={product}
          onEditClick={handleEditClick}
          onDeleteClick={handleDeleteClick}
        />
        <ProductCardContent product={product} />
        <ProductCardFooter
          product={product}
          onAddStock={onAddStock}
          onRecordUsage={onRecordUsage}
          onQuickUsage={onQuickUsage}
        />
      </Card>

      <DeleteProductDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        onConfirm={handleConfirmDelete}
        productName={product.name}
      />
    </>
  );
};

export default ProductCard;
